import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"row","padding-top":"20px"} }
const _hoisted_2 = { class: "indicator" }
const _hoisted_3 = { class: "data" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "日新增用户数", -1)
const _hoisted_5 = { class: "indicator" }
const _hoisted_6 = { class: "data" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "总用户数", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.index.dayNewUser), 1),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.index.userAmount), 1),
      _hoisted_7
    ])
  ]))
}